import { Link } from 'react-router-dom';
import { 
  Users, 
  Mail, 
  Phone, 
  Linkedin,
  Globe,
  Award,
  ArrowRight,
  MapPin
} from 'lucide-react';
import { Button } from '@/components/ui/button';

// 15 Sales Team Members - 60% Chinese (9), 40% Other nationalities (6)
const salesTeam = [
  // Leadership - Chinese
  {
    id: 1,
    name: 'Chen Wei',
    chineseName: '陈伟',
    role: 'Sales Director',
    department: 'Leadership',
    nationality: 'Chinese',
    location: 'Qinhuangdao, China',
    email: 'chen.wei@engineshipparts.com',
    phone: '+86 335 123 4567',
    bio: 'With over 18 years of experience in marine engine sales, Chen Wei leads our global sales strategy. He has built relationships with major shipping companies across Asia and oversees our entire sales operation.',
    specialization: 'Enterprise Accounts, Strategic Partnerships',
    languages: ['Mandarin', 'English', 'Japanese'],
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face'
  },
  {
    id: 2,
    name: 'Liu Xiaoming',
    chineseName: '刘晓明',
    role: 'Regional Sales Manager - Asia Pacific',
    department: 'Management',
    nationality: 'Chinese',
    location: 'Shanghai, China',
    email: 'liu.xiaoming@engineshipparts.com',
    phone: '+86 21 5678 9012',
    bio: 'Xiaoming manages our Asia Pacific region with expertise in Caterpillar and Cummins marine engines. His technical background as a marine engineer gives him unique insight into customer needs.',
    specialization: 'Caterpillar, Cummins, Asia Pacific Markets',
    languages: ['Mandarin', 'English', 'Korean'],
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face'
  },
  // International Leadership
  {
    id: 3,
    name: 'Michael Thompson',
    role: 'Regional Sales Manager - Americas',
    department: 'Management',
    nationality: 'American',
    location: 'Houston, USA',
    email: 'michael.t@engineshipparts.com',
    phone: '+1 713 555 0123',
    bio: 'Michael brings 15 years of Gulf Coast marine industry experience to our team. He specializes in offshore and commercial vessel applications throughout North and South America.',
    specialization: 'Offshore Vessels, MTU, Volvo Penta',
    languages: ['English', 'Spanish'],
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop&crop=face'
  },
  {
    id: 4,
    name: 'Hans Mueller',
    role: 'Regional Sales Manager - Europe',
    department: 'Management',
    nationality: 'German',
    location: 'Hamburg, Germany',
    email: 'hans.m@engineshipparts.com',
    phone: '+49 40 555 0123',
    bio: 'Hans oversees European operations with deep expertise in MAN and MTU engines. His engineering background and industry connections make him invaluable for complex technical sales.',
    specialization: 'MAN, MTU, European Regulations',
    languages: ['German', 'English', 'Dutch'],
    image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=400&fit=crop&crop=face'
  },
  // Senior Sales - Chinese
  {
    id: 5,
    name: 'Zhang Yan',
    chineseName: '张燕',
    role: 'Senior Sales Consultant',
    department: 'Sales',
    nationality: 'Chinese',
    location: 'Qinhuangdao, China',
    email: 'zhang.yan@engineshipparts.com',
    phone: '+86 335 234 5678',
    bio: 'Zhang Yan specializes in high-horsepower marine engines for commercial shipping. She has successfully closed deals with major shipping lines across Southeast Asia.',
    specialization: 'High-HP Engines, Commercial Shipping',
    languages: ['Mandarin', 'English', 'Vietnamese'],
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop&crop=face'
  },
  {
    id: 6,
    name: 'Wang Junhao',
    chineseName: '王俊豪',
    role: 'Senior Sales Consultant',
    department: 'Sales',
    nationality: 'Chinese',
    location: 'Dalian, China',
    email: 'wang.junhao@engineshipparts.com',
    phone: '+86 411 345 6789',
    bio: 'Junhao focuses on the fishing and workboat sector, understanding the unique demands of these hardworking vessels. His hands-on approach has earned him loyal customers.',
    specialization: 'Fishing Vessels, Workboats, Yanmar',
    languages: ['Mandarin', 'English'],
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop&crop=face'
  },
  // International Senior Sales
  {
    id: 7,
    name: 'Sarah Johnson',
    role: 'Senior Sales Consultant',
    department: 'Sales',
    nationality: 'British',
    location: 'London, UK',
    email: 'sarah.j@engineshipparts.com',
    phone: '+44 20 7946 0123',
    bio: 'Sarah specializes in the luxury yacht market, working with shipyards and private owners across Europe and the Mediterranean. Her attention to detail ensures perfect engine matches.',
    specialization: 'Luxury Yachts, Volvo Penta, Mercury',
    languages: ['English', 'French', 'Italian'],
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&crop=face'
  },
  {
    id: 8,
    name: 'Ahmed Hassan',
    role: 'Senior Sales Consultant',
    department: 'Sales',
    nationality: 'Egyptian',
    location: 'Dubai, UAE',
    email: 'ahmed.h@engineshipparts.com',
    phone: '+971 4 555 0123',
    bio: 'Ahmed covers the Middle East and North Africa region, with particular expertise in commercial vessels operating in the Red Sea and Arabian Gulf.',
    specialization: 'Middle East Markets, Commercial Vessels',
    languages: ['Arabic', 'English', 'French'],
    image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop&crop=face'
  },
  // Sales Associates - Chinese
  {
    id: 9,
    name: 'Li Mei',
    chineseName: '李梅',
    role: 'Sales Associate',
    department: 'Sales',
    nationality: 'Chinese',
    location: 'Qinhuangdao, China',
    email: 'li.mei@engineshipparts.com',
    phone: '+86 335 456 7890',
    bio: 'Li Mei provides exceptional customer support and handles inquiries from across Asia. Her product knowledge and friendly approach make customers feel at ease.',
    specialization: 'Customer Relations, Product Inquiries',
    languages: ['Mandarin', 'English', 'Cantonese'],
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop&crop=face'
  },
  {
    id: 10,
    name: 'Zhao Peng',
    chineseName: '赵鹏',
    role: 'Sales Associate',
    department: 'Sales',
    nationality: 'Chinese',
    location: 'Qinhuangdao, China',
    email: 'zhao.peng@engineshipparts.com',
    phone: '+86 335 567 8901',
    bio: 'Peng specializes in rebuilt and reconditioned engines, helping customers find quality options within their budget. His mechanical knowledge helps explain complex specifications.',
    specialization: 'Rebuilt Engines, Budget Solutions',
    languages: ['Mandarin', 'English'],
    image: 'https://images.unsplash.com/photo-1463453091185-61582044d556?w=400&h=400&fit=crop&crop=face'
  },
  {
    id: 11,
    name: 'Yang Fang',
    chineseName: '杨芳',
    role: 'Sales Associate',
    department: 'Sales',
    nationality: 'Chinese',
    location: 'Guangzhou, China',
    email: 'yang.fang@engineshipparts.com',
    phone: '+86 20 678 9012',
    bio: 'Fang covers South China and Southeast Asian markets, building strong relationships with shipyards and vessel operators throughout the region.',
    specialization: 'South China, Southeast Asia',
    languages: ['Mandarin', 'Cantonese', 'English', 'Thai'],
    image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=400&fit=crop&crop=face'
  },
  {
    id: 12,
    name: 'Huang Jie',
    chineseName: '黄杰',
    role: 'Sales Associate',
    department: 'Sales',
    nationality: 'Chinese',
    location: 'Qinhuangdao, China',
    email: 'huang.jie@engineshipparts.com',
    phone: '+86 335 789 0123',
    bio: 'Jie handles our online sales channels and international inquiries, ensuring quick response times and accurate quotations for customers worldwide.',
    specialization: 'Online Sales, International Inquiries',
    languages: ['Mandarin', 'English', 'Japanese'],
    image: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=400&h=400&fit=crop&crop=face'
  },
  // Technical Sales
  {
    id: 13,
    name: 'Takeshi Yamamoto',
    role: 'Technical Sales Specialist',
    department: 'Technical Sales',
    nationality: 'Japanese',
    location: 'Tokyo, Japan',
    email: 'takeshi.y@engineshipparts.com',
    phone: '+81 3 5555 0123',
    bio: 'Takeshi combines deep technical knowledge with sales expertise, helping customers select the right engine specifications for their specific applications.',
    specialization: 'Technical Specifications, Yanmar, Japanese Brands',
    languages: ['Japanese', 'English', 'Mandarin'],
    image: 'https://images.unsplash.com/photo-1544723795-3fb6469f5b39?w=400&h=400&fit=crop&crop=face'
  },
  // Customer Success - Chinese
  {
    id: 14,
    name: 'Sun Ling',
    chineseName: '孙玲',
    role: 'Customer Success Manager',
    department: 'Customer Success',
    nationality: 'Chinese',
    location: 'Qinhuangdao, China',
    email: 'sun.ling@engineshipparts.com',
    phone: '+86 335 890 1234',
    bio: 'Ling ensures our customers have a smooth experience from purchase to delivery. She coordinates logistics, documentation, and after-sales support.',
    specialization: 'Logistics, Documentation, After-Sales',
    languages: ['Mandarin', 'English', 'Russian'],
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=400&fit=crop&crop=face'
  },
  // Sales Support
  {
    id: 15,
    name: 'Carlos Rodriguez',
    role: 'Sales Support Specialist',
    department: 'Sales Support',
    nationality: 'Mexican',
    location: 'Mexico City, Mexico',
    email: 'carlos.r@engineshipparts.com',
    phone: '+52 55 5555 0123',
    bio: 'Carlos supports our Latin American customers with quotations, shipping coordination, and Spanish-language customer service.',
    specialization: 'Latin America, Quotations, Shipping',
    languages: ['Spanish', 'English', 'Portuguese'],
    image: 'https://images.unsplash.com/photo-1507591064344-4c6ce005b128?w=400&h=400&fit=crop&crop=face'
  }
];

const departments = ['All', 'Leadership', 'Management', 'Sales', 'Technical Sales', 'Customer Success', 'Sales Support'];

export default function TeamPage() {
  return (
    <main className="bg-slate-50">
      {/* Hero Section */}
      <section className="relative py-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900"></div>
        <div className="absolute inset-0">
          <div className="absolute top-20 right-20 w-72 h-72 bg-orange-500/20 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 left-20 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl"></div>
        </div>
        
        <div className="container-custom relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-orange-500/20 rounded-full text-orange-400 text-sm font-medium mb-6">
              <Users className="w-4 h-4" />
              Our Global Team
            </div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
              Meet Our
              <span className="text-orange-500"> Sales Team</span>
            </h1>
            <p className="text-xl text-slate-300 mb-8">
              Our diverse, multicultural team brings together expertise from around the world. 
              With representatives across 8 countries, we speak your language and understand your needs.
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              <div className="flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full">
                <Globe className="w-4 h-4 text-orange-400" />
                <span className="text-slate-300">8 Countries</span>
              </div>
              <div className="flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full">
                <Users className="w-4 h-4 text-orange-400" />
                <span className="text-slate-300">15 Specialists</span>
              </div>
              <div className="flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full">
                <Award className="w-4 h-4 text-orange-400" />
                <span className="text-slate-300">12+ Languages</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Grid */}
      <section className="py-20">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-slate-900 mb-4">Our Dedicated Professionals</h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Each member brings unique expertise and a commitment to helping you find the perfect marine engine solution.
            </p>
          </div>

          {/* Team Cards */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {salesTeam.map((member) => (
              <div 
                key={member.id}
                className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-slate-100 hover:-translate-y-2"
              >
                {/* Image */}
                <div className="relative h-64 overflow-hidden">
                  <img 
                    src={member.image} 
                    alt={member.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/20 to-transparent"></div>
                  
                  {/* Name overlay */}
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="text-xl font-bold text-white">{member.name}</h3>
                    {member.chineseName && (
                      <p className="text-orange-400 text-sm">{member.chineseName}</p>
                    )}
                    <p className="text-slate-300 text-sm">{member.role}</p>
                  </div>

                  {/* Nationality badge */}
                  <div className="absolute top-4 right-4">
                    <span className="px-3 py-1 bg-white/90 backdrop-blur-sm rounded-full text-xs font-medium text-slate-700">
                      {member.nationality}
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  {/* Location */}
                  <div className="flex items-center gap-2 text-sm text-slate-500 mb-4">
                    <MapPin className="w-4 h-4 text-orange-500" />
                    {member.location}
                  </div>

                  {/* Bio */}
                  <p className="text-slate-600 text-sm mb-4 line-clamp-3">
                    {member.bio}
                  </p>

                  {/* Specialization */}
                  <div className="mb-4">
                    <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-2">Specialization</p>
                    <p className="text-sm text-slate-700">{member.specialization}</p>
                  </div>

                  {/* Languages */}
                  <div className="mb-4">
                    <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-2">Languages</p>
                    <div className="flex flex-wrap gap-1">
                      {member.languages.map((lang, i) => (
                        <span key={i} className="px-2 py-1 bg-slate-100 rounded text-xs text-slate-600">
                          {lang}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Contact */}
                  <div className="flex items-center gap-3 pt-4 border-t border-slate-100">
                    <a 
                      href={`mailto:${member.email}`}
                      className="flex-1 flex items-center justify-center gap-2 py-2 bg-slate-100 hover:bg-orange-100 rounded-lg text-sm text-slate-700 hover:text-orange-600 transition-colors"
                    >
                      <Mail className="w-4 h-4" />
                      Email
                    </a>
                    <a 
                      href={`tel:${member.phone.replace(/\s/g, '')}`}
                      className="flex-1 flex items-center justify-center gap-2 py-2 bg-orange-500 hover:bg-orange-600 rounded-lg text-sm text-white transition-colors"
                    >
                      <Phone className="w-4 h-4" />
                      Call
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Global Presence */}
      <section className="py-20 bg-white">
        <div className="container-custom">
          <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-3xl p-12 lg:p-16">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
                  Truly Global Coverage
                </h2>
                <p className="text-lg text-slate-300 mb-6">
                  With team members across China, USA, Germany, UK, UAE, Japan, and Mexico, 
                  we provide local expertise with global reach. No matter where you are, 
                  there&apos;s a specialist who understands your market.
                </p>
                <ul className="space-y-3 text-slate-300">
                  <li className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                    Headquarters: Qinhuangdao, China
                  </li>
                  <li className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                    Regional offices in 7 countries
                  </li>
                  <li className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                    Support in 12+ languages
                  </li>
                </ul>
              </div>
              <div className="text-center">
                <div className="inline-flex items-center justify-center w-48 h-48 bg-orange-500/20 rounded-full">
                  <Globe className="w-24 h-24 text-orange-500" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gradient-to-r from-orange-500 to-red-500">
        <div className="container-custom text-center">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            Ready to Connect?
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Our team is ready to help you find the perfect marine engine. 
            Reach out today and experience the EngineShipParts difference.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/contact">
              <Button className="bg-white text-orange-600 hover:bg-slate-100 px-8 py-3 text-lg font-semibold">
                Contact Us
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </Link>
            <Link to="/inventory">
              <Button variant="outline" className="border-white text-white hover:bg-white/10 px-8 py-3 text-lg font-semibold">
                Browse Inventory
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
